import feed_avatar from '../../assets/img/recommend_avatar.png';
import recommend1 from '../../assets/img/recommend1.png';
import recommend2 from '../../assets/img/recommend2.png';
export const dataStyle = [
    {
        id: 1,
        style_name: 'Grange Style',
        name: 'Mariam',
        avatar: feed_avatar,
        list: [
            {
                id: 0,
                name: 'Very stylish Coat',
                sizes: [
                    {
                        value: 1,
                        key: '6 UK',
                    },
                    {
                        value: 2,
                        key: '7 UK',
                    },
                    {
                        value: 3,
                        key: '8 UK',
                    },
                    {
                        value: 4,
                        key: '9 UK',
                    },
                    {
                        value: 5,
                        key: '10 UK',
                    },
                ],
                colors: [
                    {
                        value: 1,
                        key: 'Black',
                    },
                    {
                        value: 2,
                        key: 'White',
                    },
                ],
                price: 1200,
                quantity: 1,
                isStyle: true,
                imgURL: recommend2,
            },
            {
                id: 1,
                name: 'Pullover',
                sizes: [
                    {
                        value: 1,
                        key: '6 UK',
                    },
                    {
                        value: 2,
                        key: '7 UK',
                    },
                    {
                        value: 3,
                        key: '8 UK',
                    },
                    {
                        value: 4,
                        key: '9 UK',
                    },
                    {
                        value: 5,
                        key: '10 UK',
                    },
                ],
                colors: [
                    {
                        value: 1,
                        key: 'Black',
                    },
                    {
                        value: 2,
                        key: 'White',
                    },
                ],
                price: 300,
                quantity: 1,
                isStyle: false,
                imgURL: recommend1,
            },
            {
                id: 2,
                name: 'Pants',
                sizes: [
                    {
                        value: 1,
                        key: '6 UK',
                    },
                    {
                        value: 2,
                        key: '7 UK',
                    },
                    {
                        value: 3,
                        key: '8 UK',
                    },
                    {
                        value: 4,
                        key: '9 UK',
                    },
                    {
                        value: 5,
                        key: '10 UK',
                    },
                ],
                colors: [
                    {
                        value: 1,
                        key: 'Black',
                    },
                    {
                        value: 2,
                        key: 'White',
                    },
                ],
                price: 400,
                quantity: 1,
                isStyle: false,
                imgURL: 'https://static.zara.net/photos///2022/V/0/1/p/0085/324/450/2/w/850/0085324450_6_1_1.jpg?ts=1644915006456',
            },
        ],
    },
];

export enum ItemStatus {
    RejectedFixed = 'rejectedFixed',
    RejectedNotFixed = 'rejectedNotFixed',
    InReview = 'inReview',
    Draft = 'draft',
    Published = 'published',
    Rejected = 'rejected',
    Unpublished = 'unpublished',
    PublishToUnlisted = 'unlisted',
    PublishToConsumers = 'private',
    ChoosePublishOption = 'ChoosePublishOption',
    Removed = 'removed',
}
export enum EStatusFilter {
    All = 'All',
    Draft = 'Draft',
    Published = 'Published',
    Unlisted = 'Unlisted',
    Private = 'Private',
}
